import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"

const TD = TypeDescriptors

const waitReadyDescriptor = {
    input: TD.inlet(TD.Identity<any>()),
    output: TD.outlet(TD.Identity<any>()),
}

export class WaitReady<T> implements NodeClassImpl<typeof waitReadyDescriptor, typeof WaitReady> {
    static descriptor = waitReadyDescriptor
    static uniqueName = "WaitReady"
    input!: Inlet<T | typeof NotReady>
    output!: Outlet<T>

    run() {
        if (this.input === NotReady) this.output.emitIfChanged(NotReady)
        else this.output.emitIfChanged(this.input)
    }
}
